import React from 'react';
import { connect } from 'react-redux';
import { setDefaultAddress } from '../../actions/auth';
import { setAccountPanel } from '../../actions/panels';
import housecurrent from '../../assets/images/house-current.svg';

import { ModalCloseButton } from '../common/ModalCloseButton';

class DeliveryAddresses extends React.Component {
    renderAddressCard(address) {
        return (
         
                <div className="profile-info-wrapper" style={{ width: "90%", marginLeft: 12}}
                     onClick={() => this.props.dispatch(setDefaultAddress(this.props.token, address.id, this.props.navigation))} 
                     key={"address"+address.id}
                >
                    <div className="information-wrapper two-columns">
                        <div className="name-title">
                            <div className="text-block-8">Address:</div>
                        </div>
                        <div className="name-info">{address.address}</div>
                    </div>


                    { address.instructions ? (
                    <div className="information-wrapper two-columns">
                        <div className="name-title">
                            <div className="text-block-8">Special Instructions:</div>
                        </div>
                        <div className="name-info special">{ address.instructions }</div>
                    </div>
                    ) : (
                        <div />
                    )}      

                    { this.props.user.defaultAddress === address.address ? (
                    <div className="default-address-wrapper">
                        <img src={housecurrent}  className="default-icon" />
                        <div>Default Address</div>
                    </div>
                      ): (
                        <div /> 
                    )}

                </div>
           
       
        );
    }

    render() {
        let addresses = this.props.user.addresses.sort((a,b) => {
            if (b.default == 1) {
                return 1;
            }

            return -1;
        });

        return (

            <div className="delivery-address-modal-padding">
                <div className="close-button">
                    <ModalCloseButton 
                            clickAction={() => this.props.dispatch(setAccountPanel('info'))} 
                        />
                </div>
                <div className="item-info-wrapper">
                    <h2 className="heading in-item">Delivery Addresses</h2>
                    <div className="account-button in-receipt usual-orders update-modal-addresses"
                       onClick={() => this.props.dispatch(setAccountPanel('new_delivery_address'))}
                       style={{ marginBottom: 10}}
                    >
                        <img src={housecurrent} loading="lazy" className="button-icon white " />
                        <div>Add a New Address</div>
                    </div>
                    {(addresses.length <= 0) && (
                        <p>No addresses found. Please add an address...</p>
                    )}
                     {addresses.map((address) => {
                        return this.renderAddressCard(address);
                    })}

               
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token,
        loading: state.auth.loading,
    };
};

export default connect(mapStateToProps)(DeliveryAddresses);
